module.exports = __webpack_public_path__ + "img/2-top.4bf14364.png";